import { render, staticRenderFns } from "./SharesTable.vue?vue&type=template&id=36d7b20a&scoped=true"
import script from "./SharesTable.vue?vue&type=script&lang=js"
export * from "./SharesTable.vue?vue&type=script&lang=js"
import style0 from "./SharesTable.vue?vue&type=style&index=0&id=36d7b20a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d7b20a",
  null
  
)

export default component.exports